<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div [class.isPrinting]="printService.isPrinting">
  <div class="row margin-bottom-10px" id="edit-link">
    <div class="col-md-12">
      <div class="card box-shadow-new-treatmentcycle border-left-freezing ">
        <div class="card-header wh-header border-bottom-1px padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
          <div class="row nav-link-hand margin-left-0px margin-right-0px background-new-freezing data-color-white">
            <div class="col-md-6 padding-right-0px">
              <label class="margin-bottom-0px font-size-16px font-weight-normal" id="Freeze">
                <!--<i class="fas fa-circle light-gray-badge nav-link-hand  ">
        </i>-->
                Cryo Preservation
              </label>
            </div>
            <div class="col-md-6  padding-right-0px display-edit" *ngIf="GradingData2">
              <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
              <div class="row  margin-left-0px margin-right-0px" *ngIf="GradingData2.ActivityStatus =='Completed'">


                <div class=" col-md-3 padding-left-0px">


                  <a class="nav-link-hand education-navlink" title="Detail" (click)="EditGrading()">
                    <span class="badge font-size-16px padding-right-0px"><i class="fa fa-info-circle"></i></span>
                  </a>

                </div>
                <div class="col-md-3 padding-right-0px ">
                  <!--<a class="nav-link-hand education-navlink " title="print" (click)="printtransfer()">
            <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
          </a>-->
                  <button type="button" class="btn actions-btn-prime float-right font-size-15px padding-right-0px padding-left-0px min-width-32px" (click)="printtransfer()"><i class="fa fa-print"></i></button>
                </div>

                <div class="col-md-3">

                  <button type="button" (click)="Top()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload">
                    <i class="fas fa-long-arrow-alt-up font-size-11"></i>
                  </button>

                </div>
                <div class="col-md-3">
                  <button type="button" (click)="Bottom()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload" title="Goto Bottom">
                    <i class="fas fa-long-arrow-alt-down font-size-11 "></i>
                  </button>
                </div>
              </div>

              <div class="row  margin-left-0px margin-right-0px" *ngIf="GradingData2.ActivityStatus !=='Completed'">


                <div class=" col-md-6 padding-right-0px">

                  <button class="btn actions-btn-prime float-right font-size-15px " type="button" (click)="EditFreezing()">
                    <i class="fas fa-pencil-alt"></i> Freezing
                  </button>

                </div>


                <div class="col-md-1">

                  <button type="button" (click)="Top()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload">
                    <i class="fas fa-long-arrow-alt-up font-size-11"></i>
                  </button>

                </div>
                <div class="col-md-1 padding-left-9px">
                  <button type="button" (click)="Bottom()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload" title="Goto Bottom">
                    <i class="fas fa-long-arrow-alt-down font-size-11 "></i>
                  </button>
                </div>
              </div>


            </div>

          </div>

          <div class="row">
            <div class="col-md-12">
              <ivf-additional-detail [CycleCode]='CycleCode'
                                     Title="Additional Information"
                                     Context="CryoAdnlDetail">
              </ivf-additional-detail>
            </div>
          </div>

        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px height-50px">
          
        </div>
      </div>

    </div>
  </div>

  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>



